import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, RouterEvent, Event } from '@angular/router';
import { IonTabs, ModalController, Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';

import { PrivilegeService } from 'src/app/services/account/privilege/privilege.service';
import { TabService } from 'src/app/services/general/tab.service';

import { TabType, ModuleType } from 'src/app/types/general';
import { CurrentPrivilege } from '../interfaces/privilege';
import { AccountsAddComponent } from '../components/accounts/accounts-add/accounts-add.component';
import { AccountsListService } from '../services/accounts/accounts-list.service';
import { User } from '../interfaces/user';
import { UserService } from '../services/user/user.service';

/**
 * Tab menu bar component
 */
@Component({
  selector: 'app-tabs',
  templateUrl: 'tabs.page.html',
  styleUrls: ['tabs.page.scss']
})
export class TabsPage implements OnInit, OnDestroy {

  /**
   * Ion tab element
   */
  @ViewChild('tabs', { static: false }) tabs: IonTabs;

  /**
   * Selected tab
   */
  selectedTab: string;
  /**
   * Tab type
   */
  tabType: TabType;
  /**
   * Show tab flag
   */
  showTab: boolean;
  isHybrid: boolean;

  currentPrivilege: CurrentPrivilege;

  accountsListSearchMode: boolean;

  user: User;

  private tabSubscription: Subscription;

  private privilegeSubscription: Subscription;
  
  private userSubscription: Subscription;

  // private accountListSearchModeSubscription: Subscription;

  /**
   * Constructor
   * @param router router
   * @param tabService Tab service
   */
  constructor(
    private platform: Platform,
    private router: Router,
    private modalController: ModalController,
    // private accountsListService: AccountsListService,
    private tabService: TabService,
    private privilegeService: PrivilegeService,
    private userService: UserService,
  ) {
    this.isHybrid = this.platform.is('hybrid');
    this.watchRoute();
    this.watchShowTab();
    this.watchPrivilege();
    this.wathcUser();
    // this.watchAccountListSearchMode();
  }

  ngOnInit(): void {
      
  }

  ngOnDestroy(): void {
    this.unwatchTab();
    this.unwatchPrivilege();
    this.unwatchUser();
    // this.unwatchAccountListSearchMode();
  }

  /**
   * Watch route
   */
  watchRoute() {
    this.router.events.subscribe((event: Event | RouterEvent) => {
      this.tabService.updateShowTab(true);
      if (event instanceof RouterEvent) {
        if (event.url?.indexOf('/tabs-guest') !== -1) {
          this.tabType = 'guest';
        } else if (event.url?.indexOf('/tabs-checkin') !== -1) {
          this.tabType = 'checkin';
        } else if (event.url?.indexOf('/tabs-gift') !== -1) {
          this.tabType = 'gift';
        } else if (event.url?.indexOf('/tabs-trash') !== -1) {
          this.tabType = 'trash';
        } else if (event.url?.indexOf('/tabs-accounts') !== -1) {
          this.tabType = 'accounts';
        } else {
          this.tabType = '';
        }
        this.setupPrivilege();
      }
    });
  }

  /**
   * Watch show tab status
   */
  watchShowTab() {
    if (!this.tabSubscription) {
      this.tabSubscription = this.tabService.observableShowTab.subscribe((showTab: boolean) => {
        if (this.showTab !== showTab) {
          this.showTab = showTab;
          this.setupPrivilege();
        }
      });
    }
  }

  unwatchTab() {
    if (this.tabSubscription) {
      this.tabSubscription.unsubscribe();
      this.tabSubscription = null;
    }
  }

  async watchPrivilege() {
    if (!this.privilegeSubscription) {
      this.privilegeSubscription = this.privilegeService.observableCurrentPrivilege.subscribe(() => {
        this.setupPrivilege();
      })
    }
  }

  async unwatchPrivilege() {
    if (this.privilegeSubscription) {
      this.privilegeSubscription.unsubscribe();
      this.privilegeSubscription = null;
    }
  }

  async wathcUser() {
    if (!this.userSubscription) {
      this.userSubscription = this.userService.observableUser.subscribe((user: User) => {
        this.user = user;
      });
    }
  }

  async unwatchUser() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
      this.userSubscription = null;
    }
  }

  // async watchAccountListSearchMode() {
  //   if (!this.accountListSearchModeSubscription) {
  //     this.accountListSearchModeSubscription = this.accountsListService.observableAccountsListSearchMode.subscribe((accountsListSearchMode: boolean) => {
  //       this.accountsListSearchMode = accountsListSearchMode;
  //     });
  //   }
  // }

  // async unwatchAccountListSearchMode() {
  //   if (this.accountListSearchModeSubscription) {
  //     this.accountListSearchModeSubscription.unsubscribe();
  //     this.accountListSearchModeSubscription = null;
  //   }
  // }

  setupPrivilege() {
    if (!this.currentPrivilege) {
      this.currentPrivilege = {};
    }
    this.currentPrivilege = {
      'gift': {
        'new': this.checkPrivilege('gift', 'new'),
      },
    };

    if (this.tabType) {
      this.currentPrivilege = {
        [this.tabType]: {
          'new': this.checkPrivilege(this.tabType, 'new'),
          'qrcode': this.checkPrivilege(this.tabType, 'qrcode'),
        },
      };
    }
  }

  /**
   * Set current tab
   */
  setCurrentTab() {
    this.selectedTab = this.tabs.getSelected();
  }

  /**
   * Check user privilege
   * @param action Action
   */
  checkPrivilege(module: ModuleType, action: string): boolean {
    return this.privilegeService.checkCurrentUserPrivilege(module, action);
  }

  async presentAccountsAddModal() {
    const modal = await this.modalController.create({
      component: AccountsAddComponent,
      cssClass: 'modal-transparent modal-login',
      initialBreakpoint: 0.5,
      breakpoints: [0.5, 0.9],
      componentProps: {

      }
    });
    modal.present();
    modal.onDidDismiss().then(() => {

    });
  }

  goProfile() {
    this.router.navigate(['/tabs-user/profile']);
  }

  // toggleAccountsListSearchMode() {
  //   this.accountsListService.setSearchMode(!this.accountsListSearchMode);
  // }
}
